"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Risk API
 * Risk Service API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceCategoryToJSON = exports.DeviceCategoryFromJSONTyped = exports.DeviceCategoryFromJSON = exports.DeviceCategory = void 0;
/**
 *
 * @export
 */
exports.DeviceCategory = {
    Unassigned: 'unassigned',
    Desktop: 'desktop',
    Firewall: 'firewall',
    Laptop: 'laptop',
    Server: 'server',
    Printer: 'printer',
    Network: 'network',
    Mobile: 'mobile',
    Embedded: 'embedded',
    Iot: 'iot',
    Other: 'other'
};
function DeviceCategoryFromJSON(json) {
    return DeviceCategoryFromJSONTyped(json, false);
}
exports.DeviceCategoryFromJSON = DeviceCategoryFromJSON;
function DeviceCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DeviceCategoryFromJSONTyped = DeviceCategoryFromJSONTyped;
function DeviceCategoryToJSON(value) {
    return value;
}
exports.DeviceCategoryToJSON = DeviceCategoryToJSON;
